import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Icon from "module-common/Icon";

export default class Field extends Component {
  static propTypes = {
    width: PropTypes.number,
    text: PropTypes.string,
    flex: PropTypes.bool,
    onClick: PropTypes.func
  };
  static defaultProps = {
    text: "Label",
    width: 100
  };

  render() {
    const { text, onClick } = this.props;
    return (
      <Wrapper {...this.props}>
        <Text>{text}</Text>
        <Icon name="arrow-down" mode="auto" onClick={onClick} />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  padding: 0 4px 0 8px;
  margin: 2px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${props => props.theme.uiText};
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 4px;
  width: ${props => props.width}px;
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
  ${props => (props.flex ? "flex: 1;" : "flex: none;")};
`;
const Text = styled.div`
  font-size: 0.78rem;
  text-overflow: ellipsis;
  white-space: nowrap;
`;



// WEBPACK FOOTER //
// ./src/module-schedule/filter/Field.js